import { render } from "./Shoes.vue?vue&type=template&id=a979c2e6"
import script from "./Shoes.vue?vue&type=script&lang=js"
export * from "./Shoes.vue?vue&type=script&lang=js"

import exportComponent from "/home/daniel/code/myawu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__